class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    
    // Ensure coupon modal closes when cart drawer closes
    if (window.CouponDrawerManager) {
        const modal = document.getElementById('coupon-modal-overlay');
        if (modal && modal.style.display !== 'none') {
            window.CouponDrawerManager.toggleViewAll();
        }
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      if(window.CouponDrawerManager) window.CouponDrawerManager.init();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* --- Custom Coupon Logic --- */
  window.CouponDrawerManager = {
    
    coupons: (window.customCartCoupons || []).filter(c => !c.applyTo || c.applyTo === 'both' || c.applyTo === 'cart').map(c => ({
      code: c.code,
      type: c.type,
      value: c.value,
      minRequirementType: c.minRequirementType || 'amount',
      minPurchase: c.minPurchase,
      minQuantity: c.minQuantity || 1,
      desc: c.desc,
      productIds: c.productIds || [],
      collectionIds: c.collectionIds || [],
      excludeProductIds: c.excludeProductIds || [],
      excludeCollectionIds: c.excludeCollectionIds || []
    })),
    state: {
      appliedCouponCode: null, 
      manuallyRemoved: false
    },

  formatMoney(cents) {
    // Basic formatter for India Locale (assuming INR). Theme usually has a robust one, but this works for demo.
    return '₹' + new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(cents / 100);
  },

  getSubtotal() {
    const el = document.getElementById('ui-total-amount');
    return el ? parseInt(el.getAttribute('data-total')) : 0;
  },

  getMrp() {
    const el = document.getElementById('ui-mrp');
    return el ? parseInt(el.getAttribute('data-mrp')) : this.getSubtotal();
  },

  getCartItemCount() {
    const el = document.getElementById('ui-total-amount');
    if (!el) return 0;
    const itemsRaw = el.getAttribute('data-cart-items');
    if (!itemsRaw) return 0;
    try {
      const items = JSON.parse(itemsRaw);
      return items.reduce((acc, item) => acc + item.quantity, 0);
    } catch(e) { return 0; }
  },

  getEligibleMetrics(coupon) {
    if (!coupon) return { subtotal: this.getSubtotal(), quantity: this.getCartItemCount() };
    
    const hasInclusions = (coupon.productIds && coupon.productIds.length > 0) || (coupon.collectionIds && coupon.collectionIds.length > 0);
    const hasExclusions = (coupon.excludeProductIds && coupon.excludeProductIds.length > 0) || (coupon.excludeCollectionIds && coupon.excludeCollectionIds.length > 0);
    
    if (!hasInclusions && !hasExclusions) {
      return { subtotal: this.getSubtotal(), quantity: this.getCartItemCount() };
    }
    
          const el = document.getElementById('ui-total-amount');
      if (!el) return { subtotal: 0, quantity: 0 };
    
    const itemsRaw = el.getAttribute('data-cart-items');
    if (!itemsRaw) return { subtotal: this.getSubtotal(), quantity: this.getCartItemCount() };
    
    try {
      const items = JSON.parse(itemsRaw);
      let eligibleSubtotal = 0;
      let eligibleQuantity = 0;
      items.forEach(item => {
        const itemCollections = item.collection_ids || [];

        let isExcluded = false;
        if (hasExclusions) {
          if (coupon.excludeProductIds && coupon.excludeProductIds.includes(item.product_id)) isExcluded = true;
          if (!isExcluded && coupon.excludeCollectionIds && coupon.excludeCollectionIds.length > 0) {
            if (itemCollections.some(cid => coupon.excludeCollectionIds.includes(cid))) isExcluded = true;
          }
        }
        
        if (isExcluded) return;
        
        let isIncluded = true;
        if (hasInclusions) {
          isIncluded = false;
          if (coupon.productIds && coupon.productIds.length > 0 && coupon.productIds.includes(item.product_id)) isIncluded = true;
          if (!isIncluded && coupon.collectionIds && coupon.collectionIds.length > 0) {
            if (itemCollections.some(cid => coupon.collectionIds.includes(cid))) isIncluded = true;
          }
        }
        
        if (isIncluded) {
          eligibleSubtotal += item.price * item.quantity;
          eligibleQuantity += item.quantity;
        }
      });
      return { subtotal: eligibleSubtotal, quantity: eligibleQuantity };
    } catch(e) {
      return { subtotal: this.getSubtotal(), quantity: this.getCartItemCount() };
    }
  },

  isEligible(coupon, metrics) {
    if (!coupon) return false;
    const reqType = coupon.minRequirementType || 'amount';
    if (reqType === 'none') return true;
    if (reqType === 'amount') return metrics.subtotal >= coupon.minPurchase;
    if (reqType === 'quantity') return metrics.quantity >= coupon.minQuantity;
    if (reqType === 'both') return metrics.subtotal >= coupon.minPurchase && metrics.quantity >= coupon.minQuantity;
    return false;
  },

  

    calculateCouponDiscount(coupon) {
    if (!coupon) return 0;
    const metrics = this.getEligibleMetrics(coupon);
    if (!this.isEligible(coupon, metrics)) return 0;

    if (coupon.type === 'percentage') {
      return Math.round(metrics.subtotal * (coupon.value / 100));
    } else if (coupon.type === 'fixed') {
      return Math.min(coupon.value, metrics.subtotal);
    }
    return 0;
  },

  findBestApplicableCoupon() {
    let bestCoupon = null;
    let maxDiscount = 0;
    this.coupons.forEach(coupon => {
      const discount = this.calculateCouponDiscount(coupon);
      if (discount > maxDiscount) {
        maxDiscount = discount;
        bestCoupon = coupon;
      }
    });
    return bestCoupon;
  },

  findNextUpsellCoupon() {
    const sortedCoupons = [...this.coupons].sort((a, b) => a.minPurchase - b.minPurchase);
    for (let coupon of sortedCoupons) {
      const metrics = this.getEligibleMetrics(coupon);
      // Only upsell if the user has at least one eligible item in their cart for this coupon
      // This prevents confusing cross-upsells between different collection-specific coupons
      if (metrics.quantity > 0 && !this.isEligible(coupon, metrics)) {
        return coupon;
      }
    }
    return null;
  },


  getUpsellMessage(coupon) {
    const metrics = this.getEligibleMetrics(coupon);
    let msg = [];
    const reqType = coupon.minRequirementType || 'amount';
    
    const amountNeeded = coupon.minPurchase - metrics.subtotal;
    const qtyNeeded = coupon.minQuantity - metrics.quantity;
    
    if (reqType === 'amount' || reqType === 'both') {
      if (amountNeeded > 0) msg.push('worth <strong style="font-weight: 500;">' + this.formatMoney(amountNeeded) + '</strong>');
    }
    if (reqType === 'quantity' || reqType === 'both') {
      if (qtyNeeded > 0) msg.push('<strong style="font-weight: 500;">' + qtyNeeded + '</strong> more item' + (qtyNeeded > 1 ? 's' : ''));
    }
    
    let expectedDiscountCents = coupon.type === 'percentage' ? Math.round(coupon.minPurchase > 0 ? coupon.minPurchase * (coupon.value / 100) : (metrics.subtotal || 1000) * (coupon.value / 100)) : coupon.value;
    let discountText = coupon.type === 'percentage' ? coupon.value + '% OFF' : this.formatMoney(expectedDiscountCents);
    
    return 'Add products ' + msg.join(' and ') + ' to save <strong style="font-weight: 500;">' + discountText + '</strong> with \'' + coupon.code + '\'';
  },



  
  



  getShortUpsellMessage(coupon) {
    const metrics = this.getEligibleMetrics(coupon);
    let msg = [];
    const reqType = coupon.minRequirementType || 'amount';
    const amountNeeded = coupon.minPurchase - metrics.subtotal;
    const qtyNeeded = coupon.minQuantity - metrics.quantity;
    
    if (reqType === 'amount' || reqType === 'both') {
      if (amountNeeded > 0) msg.push(this.formatMoney(amountNeeded) + ' more');
    }
    if (reqType === 'quantity' || reqType === 'both') {
      if (qtyNeeded > 0) msg.push(qtyNeeded + ' more item' + (qtyNeeded > 1 ? 's' : ''));
    }
    
    return 'Add ' + msg.join(' and ') + ' to unlock';
  },



  


  evaluateAndApplyCoupons() {
    let currentCoupon = this.coupons.find(c => c.code === this.state.appliedCouponCode);
    let currentDiscount = this.calculateCouponDiscount(currentCoupon);

    const bestCoupon = this.findBestApplicableCoupon();
    const bestDiscount = this.calculateCouponDiscount(bestCoupon);

    if (!this.state.manuallyRemoved) {
      if (bestDiscount > currentDiscount) {
        this.state.appliedCouponCode = bestCoupon ? bestCoupon.code : null;
      }
    } else {
      if (currentCoupon && currentDiscount === 0) {
        this.state.appliedCouponCode = null; 
      }
    }
  },

  removeCoupon() {
    this.state.appliedCouponCode = null;
    this.state.manuallyRemoved = true;
    this.render();
  },

  applyManual() {
    const input = document.getElementById('manual-coupon-input').value.trim().toUpperCase();
    const coupon = this.coupons.find(c => c.code === input);
    if(coupon) {
      this.state.appliedCouponCode = coupon.code;
      this.state.manuallyRemoved = false;
      this.render();
    } else {
      alert("Invalid coupon code or minimum purchase not met.");
    }
  },

  render() {
    this.renderProgressBar();
    
    const container = document.getElementById('coupon-container');
    if (!container) return; // cart is empty or drawer not fully loaded

    const couponSection = container.closest('.coupon-section');
    const relevantCoupons = this.coupons.filter(c => this.getEligibleMetrics(c).subtotal > 0);
    
    if (relevantCoupons.length === 0) {
      if (couponSection) couponSection.style.display = 'none';
    } else {
      if (couponSection) couponSection.style.display = 'block';
    }

    this.evaluateAndApplyCoupons();

    const subtotal = this.getSubtotal();
    const activeCoupon = this.coupons.find(c => c.code === this.state.appliedCouponCode);
    const couponDiscount = this.calculateCouponDiscount(activeCoupon);
    const nextCoupon = this.findNextUpsellCoupon();

            const mrp = this.getMrp();
    const itemDiscount = mrp - subtotal;
    let finalTotal = subtotal - couponDiscount;
    const totalSavings = itemDiscount + couponDiscount;

    const footerWrapper = document.querySelector('.cart-drawer__footer');
    let shippingFee = 0;
    if (footerWrapper) {
      const baseShippingFee = parseInt(footerWrapper.getAttribute('data-shipping-fee')) || 0;
      const shippingThreshold = parseInt(footerWrapper.getAttribute('data-shipping-threshold')) || Infinity;
      
      if (finalTotal < shippingThreshold) {
        shippingFee = baseShippingFee;
      }
      
      const shippingUI = document.getElementById('ui-shipping-fee');
      if (shippingUI) {
        const freeText = shippingUI.getAttribute('data-free-text') || 'Free';
        if (shippingFee === 0 && baseShippingFee > 0) {
          shippingUI.innerHTML = '<span style="color: #00b07a; font-weight: normal;">' + freeText + '</span> <span class="strikethrough" style="text-decoration: line-through; color: #8e9aab; margin-left: 0.3rem;">' + this.formatMoney(baseShippingFee) + '</span>';
        } else if (shippingFee === 0) {
          shippingUI.innerHTML = '<span style="color: #00b07a; font-weight: normal;">' + freeText + '</span>';
        } else {
          shippingUI.innerHTML = '<span>' + this.formatMoney(shippingFee) + '</span>';
        }
      }
    }
    finalTotal += shippingFee;

    // Read customizable texts from data attributes
    const successTextTpl = container.getAttribute('data-success-text') || 'Discount applied with [code]! You saved [amount]';
    const successEmoji = container.getAttribute('data-success-emoji') || '🥳';
    const couponLabel = container.getAttribute('data-coupon-label') || 'Coupon code';
    const removeText = container.getAttribute('data-remove-text') || 'Remove';
    const applyText = container.getAttribute('data-apply-text') || 'Apply';
    const inputPlaceholder = container.getAttribute('data-input-placeholder') || 'Enter coupon code';

    let couponHTML = '';

    if (activeCoupon && couponDiscount > 0) {
      const successMsg = successTextTpl.replace('[code]', activeCoupon.code).replace('[amount]', this.formatMoney(couponDiscount));
      couponHTML += `
        <div class="coupon-box" style="border: 1px solid #00b07a; border-radius: 8px; padding: 0.4rem 0.8rem; display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.8rem; background: #fff;">
            <div class="coupon-details" style="display: flex; flex-direction: column;">
                <span class="coupon-label" style="font-size: 0.9rem; color: #8e9aab; text-transform: uppercase;">${couponLabel}</span>
                <span class="coupon-code" style="font-size: 1.3rem; font-weight: 500; color: #1c2b41; margin-top: 0.1rem;">${activeCoupon.code}</span>
            </div>
            <button class="remove-btn" onclick="window.CouponDrawerManager.removeCoupon()" style="color: #dc3545; font-size: 1.2rem; font-weight: 500; background: none; border: none; cursor: pointer;">${removeText}</button>
        </div>
        <div class="coupon-success" style="display: flex; justify-content: space-between; align-items: center; padding: 0.5rem 0.5rem;">
            <div class="coupon-success-text" style="color: #00b07a; font-size: 1.2rem; display: flex; align-items: center; gap: 0.5rem;">
                <span style="font-size: 1.4rem;">${successEmoji}</span> ${successMsg}
            </div>
        </div>
      `;
    } else {
      couponHTML += `
        <div class="coupon-box unapplied" style="border: 1px solid #e2e8f0; border-radius: 8px; padding: 0.4rem 0.8rem; display: flex; justify-content: space-between; align-items: center; background: #fff;">
            <div class="coupon-details" style="width: 100%;">
                <input type="text" placeholder="${inputPlaceholder}" style="border: none; background: transparent; font-size: 1.2rem; outline: none; width: 100%; color: #1c2b41;" id="manual-coupon-input">
            </div>
            <button class="remove-btn" onclick="window.CouponDrawerManager.applyManual()" style="color: #dc3545; font-size: 1.2rem; font-weight: 500; background: none; border: none; cursor: pointer;">${applyText}</button>
        </div>
      `;
    }

    if (nextCoupon) {
      couponHTML += `
        <div class="upsell-box" style="margin-top: 1.5rem; background: #eef7f5; border-radius: 8px; padding: 1.2rem; display: flex; align-items: center; gap: 1.2rem;">
            <div style="background: #00b07a; border-radius: 4px; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; padding: 4px;">
                <img src="${window.upsellIconUrl || ''}" width="20" height="20" style="filter: brightness(0) invert(1);" alt="%" onerror="this.style.display='none'">
            </div>
            <div style="font-size: 1.2rem; color: #1c2b41; line-height: 1.4;">
                ${this.getUpsellMessage(nextCoupon)}
              </div>
          </div>
        `;
      }
  
      container.innerHTML = couponHTML;
  
      // Update Pricing Summary
      const couponRow = document.getElementById('row-coupon-discount');
      if (couponRow) {
        if (couponDiscount > 0) {
          couponRow.style.display = 'flex';
          document.getElementById('ui-coupon-discount').innerText = `- ${this.formatMoney(couponDiscount)}`;
        } else {
          couponRow.style.display = 'none';
        }
      }
  
      const totalEl = document.getElementById('ui-total-amount');
      if(totalEl) totalEl.innerText = this.formatMoney(finalTotal);

      const footerTotalEl = document.getElementById('ui-footer-total');
      if(footerTotalEl) footerTotalEl.innerText = this.formatMoney(finalTotal);
      
      const savingsBanner = document.getElementById('ui-total-savings');
      const savingsAmountEl = document.getElementById('ui-banner-savings');
      if(savingsBanner) {
        if (totalSavings > 0) {
            savingsBanner.style.display = 'block';
            if (savingsAmountEl) savingsAmountEl.innerText = this.formatMoney(totalSavings);
        } else {
            savingsBanner.style.display = 'none';
        }
      }
    },

  togglePricing() {
      const details = document.getElementById('pricing-details');
      const icon = document.getElementById('pricing-icon');
      if (details) {
          if (details.style.display === 'none') {
              details.style.display = 'block';
              icon.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>';
          } else {
              details.style.display = 'none';
              icon.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
          }
      }
  },

  toggleViewAll() {
      const modal = document.getElementById('coupon-modal-overlay');
      if (!modal) return;
      
      if (modal.style.display === 'none' || !modal.style.display) {
          // Open Modal
          modal.style.display = 'flex';
          
          // Populate list
          const list = document.getElementById('coupon-modal-list');
          
          let availableHtml = '';
          let moreOffersHtml = '<div style="font-weight: 700; font-size: 1.4rem; color: #333; margin-top: 2rem; margin-bottom: 1.5rem;">More offers</div>';
          
          let hasAvailable = false;
          let hasMore = false;
          
                      this.coupons.forEach(c => {
                const metrics = this.getEligibleMetrics(c);
                const eligible = this.isEligible(c, metrics);
                
                // Calculate potential savings
                let savingsVal = 0;
                if (c.type === 'percentage') {
                    const baseAmt = eligible ? metrics.subtotal : (c.minRequirementType === 'amount' ? c.minPurchase : metrics.subtotal || 10000);
                    savingsVal = Math.round(baseAmt * (c.value / 100));
                } else {
                    savingsVal = c.value;
                }
              const savingsText = this.formatMoney(savingsVal);
              const tabText = c.type === 'percentage' ? `${c.value}% OFF` : `₹${c.value/100} OFF`;
              const tabColor = eligible ? '#0a8a5b' : '#959db1';
              
              const htmlStr = `
                  <div style="display: flex; border-radius: 12px; overflow: hidden; background: #ffffff; box-shadow: 0 2px 10px rgba(0,0,0,0.04); margin-bottom: 0.8rem; position: relative;">
                    <!-- Left Tab -->
                    <div style="background: ${tabColor}; color: white; width: 44px; display: flex; align-items: center; justify-content: center; position: relative;">
                      <div style="position: absolute; left: -8px; top: 50%; transform: translateY(-50%); width: 16px; height: 16px; background: #faf8f3; border-radius: 50%;"></div>
                      <span style="transform: rotate(-90deg); white-space: nowrap; font-weight: 700; font-size: 1.2rem; letter-spacing: 0.5px;">
                         ${tabText}
                      </span>
                    </div>
                    
                    <!-- Right Content -->
                    <div style="padding: 1rem; flex: 1; border: 1px solid rgba(0,0,0,0.06); border-left: none; border-radius: 0 12px 12px 0;">
                      <div style="display: flex; justify-content: space-between; align-items: center;">
                        <div style="flex: 1;">
                          <div style="color: ${tabColor}; font-weight: 600; font-size: 1.2rem; margin-bottom: 0.2rem;">
                            Save ${savingsText} on this order
                          </div>
                          <div style="font-size: 1.6rem; font-weight: 500; color: #2b394f; margin-bottom: 0.2rem;">
                            ${c.code}
                          </div>
                          <div style="font-size: 1.1rem; color: #6a7489; line-height: 1.4; padding-right: 1rem;">
                            ${c.desc}
                          </div>
                          ${!eligible ? `
                            <div style="color: #f26622; font-size: 1.1rem; font-weight: 500; margin-top: 0.4rem;">
                              ${this.getShortUpsellMessage(c)}
                            </div>
                          ` : ''}
                        </div>
                        
                        ${eligible ? `
                          <button onclick="window.CouponDrawerManager.applyFromModal('${c.code}')" style="background: #ffffff; color: #f26622; border: 1px solid #f26622; border-radius: 20px; padding: 0.4rem 1.4rem; font-weight: 600; font-size: 1.2rem; cursor: pointer; transition: all 0.2s; white-space: nowrap;">
                            Apply
                          </button>
                        ` : ''}
                      </div>
                    </div>
                  </div>
              `;
              
              if (eligible) {
                  availableHtml += htmlStr;
                  hasAvailable = true;
              } else {
                  moreOffersHtml += htmlStr;
                  hasMore = true;
              }
          });
          
          list.innerHTML = (hasAvailable ? availableHtml : '') + (hasMore ? moreOffersHtml : '');
          
          setTimeout(() => {
              modal.style.transform = 'translateY(0)';
          }, 10);
      } else {
          // Close Modal
          modal.style.transform = 'translateY(100%)';
          setTimeout(() => {
              modal.style.display = 'none';
          }, 300);
      }
  },
  
  applyFromModal(code) {
      this.state.appliedCouponCode = code;
      this.state.manuallyRemoved = false;
      this.render();
      this.toggleViewAll();
  },

  init() {
    this.render();
  },

  renderProgressBar() {
    const container = document.getElementById('cart-progress-container');
    if (!container) return;
    
    const subtotal = this.getSubtotal();
    if (subtotal === 0) {
      container.innerHTML = '';
      return;
    }

    // Use the custom milestones from liquid
    const rawMilestones = window.customProgressMilestones || [];
    const milestones = rawMilestones.filter(m => m.minPurchase > 0).sort((a, b) => a.minPurchase - b.minPurchase);
    if (milestones.length === 0) return;

    let targetCoupon = null;
    let highestUnlocked = null;
    let progressPercent = 0;

    const step = 100 / milestones.length;

    for (let i = 0; i < milestones.length; i++) {
      let m = milestones[i];
      if (subtotal >= m.minPurchase) {
        highestUnlocked = m;
        progressPercent = (i + 1) * step;
      } else {
        if (!targetCoupon) {
            targetCoupon = m;
            const prevMilestone = i > 0 ? milestones[i-1].minPurchase : 0;
            const prevPercent = i > 0 ? (i * step) : 0;
            const range = m.minPurchase - prevMilestone;
            const amountInSegment = Math.max(0, subtotal - prevMilestone);
            const segmentProgress = range > 0 ? (amountInSegment / range) * step : 0;
            progressPercent = prevPercent + segmentProgress;
        }
      }
    }
    
    if (progressPercent > 100) progressPercent = 100;

    let headerHtml = '';
    if (targetCoupon) {
      const amountNeeded = targetCoupon.minPurchase - subtotal;
      headerHtml = `
          <div style="text-align: center; font-size: 1.3rem; color: #1c2b41; font-weight: 500;">
              You are <strong style="font-weight: 700;">${this.formatMoney(amountNeeded)}</strong> away from ${targetCoupon.value}% Discount! 🚀
          </div>
      `;
    } else {
      headerHtml = `
          <div style="text-align: center; font-size: 1.3rem; color: #1c2b41; font-weight: 500;">
              You just unlocked ${highestUnlocked ? highestUnlocked.value : 'Maximum'}% Discount! 🎉
          </div>
      `;
    }

    // Nodes
    let nodesHtml = milestones.map((m, index) => {
      const leftPct = (index + 1) * step;
      const isReached = subtotal >= m.minPurchase;
      const bgColor = isReached ? '#00b07a' : '#ffffff';
      const borderColor = isReached ? '#00b07a' : '#c3c9db';
      
      // Node itself is a tiny dot.
      return `
      <div style="position: absolute; left: ${leftPct}%; top: 50%; transform: translate(-50%, -50%); display: flex; flex-direction: column; align-items: center; z-index: 5;">
          <!-- Tiny Dot Node -->
          <div style="width: 12px; height: 12px; background-color: ${bgColor}; border: 2px solid ${borderColor}; border-radius: 50%; display: block; transition: all 0.3s ease; box-shadow: 0 0 0 3px #ffffff;"></div>
          
          <!-- Discount Reward Below -->
          <div style="position: absolute; top: 100%; left: 50%; transform: translateX(-50%); margin-top: 10px; font-size: 1.1rem; font-weight: 600; color: #6a7b92; white-space: nowrap;">
              ${m.value}% OFF
          </div>
      </div>
      `;
    }).join('');

    container.innerHTML = `
      <div style="background: #ffffff; border-radius: 8px; padding: 1.5rem 1.5rem 3rem 1.5rem; display: flex; flex-direction: column; margin: 0 0 1.5rem 0; border: 1px solid #e9ecf4; box-shadow: 0 2px 4px rgba(0,0,0,0.02);">
        ${headerHtml}
        
        <!-- Progress Bar Wrapper -->
        <div style="position: relative; width: calc(100% - 40px); margin: 1.5rem auto 1.5rem auto;">
          
          <!-- Background & Fill Track -->
          <div style="width: 100%; height: 6px; background-color: #e9ecf4; border-radius: 3px; overflow: hidden; display: block; position: relative;">
            <div style="position: absolute; top: 0; left: 0; height: 6px; min-height: 6px; background: #00b07a !important; width: ${progressPercent.toFixed(2)}% !important; transition: width 0.3s ease; display: block; z-index: 1;"></div>
          </div>
          
          <!-- Nodes -->
          ${nodesHtml}
          
        </div>
      </div>
    `;
  }
};

// Initial run when script loads if drawer is already present
document.addEventListener('DOMContentLoaded', () => {
  window.CouponDrawerManager.init();
});
















